/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import appContext from 'scripts/app-context';
import template from './tooltip-icon.stache';

Component.extend({
    tag: 'tooltip-icon',
    template: template,
    viewModel: {
        define: {
            text: {
                type: 'string',
                value: '',
            },
        },
    },
    events: {
        inserted() {
            this.tooltipContainer = this.element
                .find('tooltip-container')
                .viewModel({ icon: this.element.find('.js-tooltip-icon') });
            this.registerModelListeners();
        },
        registerModelListeners() {
            appContext.model.screen.bind('scrollOffset', () =>
                this.tooltipContainer.hide(),
            );
            appContext.model.screen.bind('screenSize', () =>
                this.tooltipContainer.hide(),
            );
            //hide tooltip on context model event 'video-recap-slider-move'
            appContext.model.bind('video-recap-slider-move', () => {
                this.tooltipContainer.hide();
            });
        },
        '.js-tooltip-icon mouseenter'() {
            this.tooltipContainer.show();
        },
        '.js-tooltip-icon mouseleave'() {
            this.tooltipContainer.hide();
        },
        '.js-tooltip-icon click'() {
            this.tooltipContainer.show();
        },
    },
});
